
import React from 'react';
import DailyTile, { MealInfo } from '@/components/ui/daily-tile';
import { Recipe } from '@/types/recipe';
import { MealCompositionWithRecipes } from '@/types/mealComposition';

interface CalendarHistoryTileProps {
  date: Date;
  itemsData: { type: 'recipe' | 'composition'; item: Recipe | MealCompositionWithRecipes; mealType: 'breakfast' | 'lunch' | 'dinner'; authorFirstName?: string }[] | null;
  isToday: boolean;
}

const CalendarHistoryTile: React.FC<CalendarHistoryTileProps> = ({ 
  date, 
  itemsData, 
  isToday 
}) => {
  // Convert items data to MealInfo format
  const meals: MealInfo[] = itemsData ? itemsData.map(({ type, item, mealType, authorFirstName }) => {
    if (type === 'recipe') {
      const recipe = item as Recipe;
      return {
        type: 'recipe' as const,
        id: recipe.id,
        name: recipe.title,
        isQuickRecipe: recipe.isQuickRecipe,
        prepTime: recipe.prepTime,
        cookTime: recipe.cookTime,
        mealType: mealType,
        imageUrl: recipe.image_url,
        storageImageUrl: recipe.storage_image_url,
        userImageUrl: recipe.user_image_url,
        storageImagePath: recipe.storage_image_path,
        userImagePath: recipe.user_image_path,
        authorFirstName: authorFirstName
      };
    } else {
      const composition = item as MealCompositionWithRecipes;
      return {
        type: 'composition' as const,
        id: composition.id,
        name: composition.name,
        recipeCount: composition.recipes.length,
        mealType: mealType,
        authorFirstName: authorFirstName
      };
    }
  }) : [];

  return (
    <DailyTile
      date={date}
      meals={meals}
      showStatusDot={false}
      variant={isToday ? 'today' : 'default'}
      showAllMealTypes={true}
      heightMode="flexible"
    />
  );
};

export default CalendarHistoryTile;
